const W = 0.52;
const M = 0.06;

export const mainKeys = {
  key_esc: {
    text: "Esc",
    style: {
      marginRight: M * 2 + W + "rem",
    },
  },
  key_f1: {
    text: "F1",
  },
  key_f2: {
    text: "F2",
  },
  key_f3: {
    text: "F3",
  },
  key_f4: {
    text: "F4",
    style: {
      marginRight: M + (M + W) * 0.5 + "rem",
    },
  },
  key_f5: {
    text: "F5",
  },
  key_f6: {
    text: "F6",
  },
  key_f7: {
    text: "F7",
  },
  key_f8: {
    text: "F8",
    style: {
      marginRight: M + (M + W) * 0.5 + "rem",
    },
  },
  key_f9: {
    text: "F9",
  },
  key_f10: {
    text: "F10",
  },
  key_f11: {
    text: "F11",
  },
  key_f12: {
    text: "F12",
  },
  key_GAT: {
    text: "~<br/>`",
  },
  key_1: {
    text: "!<br/>1",
  },
  key_2: {
    text: "@<br/>2",
  },
  key_3: {
    text: "#<br/>3",
  },
  key_4: {
    text: "$<br/>4",
  },
  key_5: {
    text: "%<br/>5",
  },
  key_6: {
    text: "^<br/>6",
  },
  key_7: {
    text: "&<br/>7",
  },
  key_8: {
    text: "*<br/>8",
  },
  key_9: {
    text: "(<br/>9",
  },
  key_0: {
    text: ")<br/>0",
  },
  key_mis: {
    text: "_<br/>-",
  },
  key_equ: {
    text: "+<br/>=",
  },
  key_backspace: {
    text: "Backspace",
    style: {
      width: W * 2 + M + "rem",
    },
  },
  key_tab: {
    text: "Tab",
    style: {
      width: W + (W + M) * 0.5 + "rem",
    },
  },
  key_q: {
    text: "Q",
  },
  key_w: {
    text: "W",
  },
  key_e: {
    text: "E",
  },
  key_r: {
    text: "R",
  },
  key_t: {
    text: "T",
  },
  key_y: {
    text: "Y",
  },
  key_u: {
    text: "U",
  },
  key_i: {
    text: "I",
  },
  key_o: {
    text: "O",
  },
  key_p: {
    text: "P",
  },
  key_oqo: {
    text: "{<br/>[",
  },
  key_eqo: {
    text: "}<br/>]",
  },
  key_bsl: {
    text: "|<br/>\\",
    style: {
      width: W + (W + M) * 0.5 + "rem",
    },
  },
  key_cap: {
    text: "CapsLock",
    style: {
      width: W + W * 0.75 + M + "rem",
    },
  },
  key_a: {
    text: "A",
  },
  key_s: {
    text: "S",
  },
  key_d: {
    text: "D",
  },
  key_f: {
    text: "F",
  },
  key_g: {
    text: "G",
  },
  key_h: {
    text: "H",
  },
  key_j: {
    text: "J",
  },
  key_k: {
    text: "K",
  },
  key_l: {
    text: "L",
  },
  key_COL: {
    text: ":<br/>;",
  },
  key_CC: {
    text: "\"<br/>'",
  },
  key_enter: {
    text: "Enter",
    style: {
      width: W + W * 1.25 + M + "rem",
    },
  },
  key_shift_l: {
    text: "LShift",
    style: {
      width: W + W * 1.25 + M * 1.5 + "rem",
    },
  },
  key_z: {
    text: "Z",
  },
  key_x: {
    text: "X",
  },
  key_c: {
    text: "C",
  },
  key_v: {
    text: "V",
  },
  key_b: {
    text: "B",
  },
  key_n: {
    text: "N",
  },
  key_m: {
    text: "M",
  },
  key_CMA: {
    text: "<<br/>,",
  },
  key_DOT: {
    text: "><br/>.",
  },
  key_SL: {
    text: "?<br/>/",
  },
  key_shift_r: {
    text: "RShift",
    style: {
      width: W + W * 1.75 + M * 1.5 + "rem",
    },
  },
  key_ctrl_l: {
    text: "LCtrl",
    style: {
      width: W * 1.3 + "rem",
    },
  },
  key_win_l: {
    text: "LWin/Cmd",
    style: {
      width: W * 1.3 + "rem",
    },
  },
  key_alt_l: {
    text: "LAlt/Opt",
    style: {
      width: W * 1.3 + "rem",
    },
  },
  key_space: {
    text: "Space",
    style: {
      width: W * 6.59 + M + "rem",
    },
  },
  key_alt_r: {
    text: "RAlt/Opt",
    style: {
      width: W * 1.3 + "rem",
    },
  },
  key_win_r: {
    text: "RWin/Cmd",
    style: {
      width: W * 1.3 + "rem",
    },
  },
  key_app: {
    text: "Menu",
    style: {
      width: W * 1.3 + "rem",
    },
  },
  key_ctrl_r: {
    text: "RCtrl",
    style: {
      width: W * 1.3 + "rem",
    },
  },
};

export const centerClusterKeys = {
  key_print: {
    text: "Print Screen",
  },
  key_scroll: {
    text: "Scroll Lock",
  },
  key_pause: {
    text: "Pause",
  },
  key_insert: {
    text: "Insert",
  },
  key_home: {
    text: "Home",
  },
  key_pgup: {
    text: "Page Up",
  },
  key_delete: {
    text: "Delete",
  },
  key_end: {
    text: "End",
  },
  key_pgdn: {
    text: "Page Down",
  },
  key_up: {
    text: "↑",
    style: {
      marginTop: M + W + "rem",
      marginRight: M + W + "rem",
      marginLeft: M + W + "rem",
    },
  },
  key_left: {
    text: "←",
  },
  key_down: {
    text: "↓",
  },
  key_right: {
    text: "→",
  },
};

export const numpadKeys = {
  // key_play_h: {
  //   text: "Play/ Pause",
  // },
  // key_mute_h: {
  //   text: "Mute",
  // },
  // key_vol_dec_h: {
  //   text: "Volume Down",
  // },
  // key_vol_add_h: {
  //   text: "Volume Up",
  // },
  key_numlock: {
    text: "Num Lock",
    style: {
      marginTop: M + W + "rem",
    },
  },
  key_num_PADNSL: {
    text: "/",
    style: {
      marginTop: M + W + "rem",
    },
  },
  key_num_PADNMU: {
    text: "*",
    style: {
      marginTop: M + W + "rem",
    },
  },
  key_num_PADNMI: {
    text: "-",
    style: {
      marginTop: M + W + "rem",
    },
  },
  key_num_7: {
    text: "7",
  },
  key_num_8: {
    text: "8",
  },
  key_num_9: {
    text: "9",
  },
  key_num_PADNPL: {
    text: "+",
  },
  key_num_4: {
    text: "4",
  },
  key_num_5: {
    text: "5",
  },
  key_num_6: {
    text: "6",
    style: {
      marginRight: M + W + "rem",
    },
  },
  key_num_1: {
    text: "1",
  },
  key_num_2: {
    text: "2",
  },
  key_num_3: {
    text: "3",
    style: {
      marginRight: M + W + "rem",
    },
  },
  key_num_0: {
    text: "0",
    style: {
      width: M + W * 2 + "rem",
    },
  },
  key_num_del: {
    text: ".",
  },
  key_num_enter: {
    text: "Enter",
  },
};

export const mediaKeys = {
  key_media_mute: {
    text: "Mute",
  },
  key_media_volume_up: {
    text: "Volume Up",
  },
  key_media_volume_down: {
    text: "Volume Down",
  },
  key_media_prev_track: {
    text: "Prev Track",
  },
  key_media_next_track: {
    text: "Next Track",
  },
  key_media_play_pause: {
    text: "Play/ Pause",
  },
};

export const r2Keys = {
  key_led_cmd_on_off_led: {
    text: "LED On/Off",
    desc: {
      cn: "屏幕关闭/打开",
      en: "Display On/Off",
    },
  },
  key_led_cmd_next_page: {
    text: "Next LED",
    desc: {
      cn: "下一个屏幕灯模式",
      en: "Next display",
    },
  },
  key_led_cmd_lightness_add: {
    text: "LED Light+",
    desc: {
      cn: "屏幕灯亮度 +",
      en: "Display brightness +",
    },
  },
  key_led_cmd_lightness_reduce: {
    text: "LED Light-",
    desc: {
      cn: "屏幕灯亮度 -",
      en: "Display brightness -",
    },
  },
  key_led_cmd_speed_add: {
    text: "LED Speed+",
    desc: {
      cn: "屏幕灯速度 +",
      en: "Display speed +",
    },
  },
  key_led_cmd_speed_reduce: {
    text: "LED Speed-",
    desc: {
      cn: "屏幕灯速度 -",
      en: "Display speed -",
    },
  },
  key_local_key_mode_cmd_on_off: {
    text: "PCB On/Off",
    desc: {
      cn: "PCB 灯开关",
      en: "PCB lighting On/Off",
    },
  },
  key_local_key_next_mode: {
    text: "Next PCB",
    desc: {
      cn: "下一个 PCB 灯模式",
      en: "Next PCB lighting mode",
    },
  },
  key_local_key_mode_lightness_add: {
    text: "PCB Light+",
    desc: {
      cn: "PCB 灯亮度 +",
      en: "PCB lighting brightness +",
    },
  },
  key_local_key_mode_lightness_reduce: {
    text: "PCB Light-",
    desc: {
      cn: "PCB 灯亮度 -",
      en: "PCB lighting brightness -",
    },
  },
  key_led_cmd_ble_shfit1: {
    text: "BT_1",
    desc: {
      cn: "切换到蓝牙通道 1",
      en: "Switch to Bluetooth channel 1",
    },
  },
  key_led_cmd_ble_shfit2: {
    text: "BT_2",
    desc: {
      cn: "切换到蓝牙通道 2",
      en: "Switch to Bluetooth channel 2",
    },
  },
  key_led_cmd_ble_shfit3: {
    text: "BT_3",
    desc: {
      cn: "切换到蓝牙通道 3",
      en: "Switch to Bluetooth channel 3",
    },
  },
  key_led_cmd_ble_2_4g: {
    text: "2.4G",
    desc: {
      cn: "切换到 2.4G",
      en: "Switch to 2.4G",
    },
  },
  key_led_cmd_factory_reset: {
    text: "Reset",
    desc: {
      cn: "恢复出厂设置",
      en: "Factory reset",
    },
  },

  key_cmd_set_key_layer1: {
    text: "Layer1",
    desc: {
      cn: "切换到键层 1",
      en: "Set to key layer 1",
    },
  },
  key_hold_set_key_layer1: {
    text: "Fn1",
    desc: {
      cn: "按住切换到键层 1",
      en: "Press and hold to switch to key layer 1",
    },
  },
  key_cmd_set_key_layer2: {
    text: "Layer2",
    desc: {
      cn: "切换到键层 2",
      en: "Set to key layer 2",
    },
  },
  key_cmd_set_key_layer3: {
    text: "Layer3",
    desc: {
      cn: "切换到键层 3",
      en: "Set to key layer 3",
    },
  },
  KEY_FN: {
    text: "Fn2",
    desc: {
      cn: "按住切换到键层 2",
      en: "Press and hold to switch to key layer 2",
    },
  },
  key_cmd_set_key_layer4: {
    text: "Layer4",
    desc: {
      cn: "切换到键层 4",
      en: "Set to key layer 4",
    },
  },
  key_cmd_set_key_layer5: {
    text: "Layer5",
    desc: {
      cn: "切换到键层 5",
      en: "Set to key layer 5",
    },
  },
  key_cmd_set_key_layer6: {
    text: "Layer6",
    desc: {
      cn: "切换到键层 6",
      en: "Set to key layer 6",
    },
  },
  key_cmd_set_key_layer7: {
    text: "Layer7",
    desc: {
      cn: "切换到键层 7",
      en: "Set to key layer 7",
    },
  },

  key_hold_set_key_layer3: {
    text: "Fn3",
    desc: {
      cn: "按住切换到键层 3",
      en: "Press and hold to switch to key layer 3",
    },
  },
  key_hold_set_key_layer4: {
    text: "Fn4",
    desc: {
      cn: "按住切换到键层 4",
      en: "Press and hold to switch to key layer 4",
    },
  },
  key_hold_set_key_layer5: {
    text: "Fn5",
    desc: {
      cn: "按住切换到键层 5",
      en: "Press and hold to switch to key layer 5",
    },
  },
  key_hold_set_key_layer6: {
    text: "Fn6",
    desc: {
      cn: "按住切换到键层 6",
      en: "Press and hold to switch to key layer 6",
    },
  },
  key_hold_set_key_layer7: {
    text: "Fn7",
    desc: {
      cn: "按住切换到键层 7",
      en: "Press and hold to switch to key layer 7",
    },
  },
};
